import React from 'react';

/* Styled Components */
import { WishTextInput as StyledWishTextInput } from 'styles/common/WishTextInput';

/* HOCs */
import type { InjectedPropsType as WishTextInputHOCInjectedPropsType } from 'components/hoc/WishTextInputHOC';
import WishTextInputHOC from 'components/hoc/WishTextInputHOC';

type PropsType = WishTextInputHOCInjectedPropsType & {
  isWarningShown?: boolean;
  isSuccessShown?: boolean;
  textAlign?: string;
  isTextArea?: boolean;
  minLength?: string;
  maxLength?: string;
  value: string | null | undefined;
  placeholder?: string;
  onChange?: (arg0: React.SyntheticEvent<HTMLInputElement>) => void;
  onPaste?: () => void;
  autoComplete?: string;
  autoFocus?: boolean;
  label?: string;
  'data-id'?: string;
  minHeight?: string;
  lineHeight?: string;
  resize?: string;
  onBlur?: (arg0: React.SyntheticEvent<HTMLInputElement>) => void;
  onClick?: (arg0: React.SyntheticEvent<HTMLInputElement>) => void;
  name?: string;
  boxSizing?: string;
  userSelect?: string;
  flex?: string;
  testId?: string;
  inputMode?: string;
  pattern?: string;
};

const WishTextInput = ({
  type,
  onKeyDown,
  padding,
  setRef,
  isErrorShown,
  isWarningShown,
  isSuccessShown,
  textAlign,
  disabled,
  isTextArea,
  minLength,
  maxLength,
  value,
  placeholder,
  onChange,
  onPaste,
  autoComplete,
  autoFocus,
  label,
  'data-id': dataID,
  lineHeight,
  resize,
  minHeight,
  onBlur,
  onClick,
  name,
  boxSizing,
  userSelect,
  testId,
  inputMode,
  pattern,
  ...passedProps
}: PropsType) => (
  <StyledWishTextInput
    type={type}
    onKeyDown={onKeyDown}
    padding={padding}
    ref={setRef}
    isErrorShown={isErrorShown}
    isWarningShown={isWarningShown}
    isSuccessShown={isSuccessShown}
    textAlign={textAlign}
    disabled={disabled}
    as={isTextArea ? 'textarea' : undefined}
    minLength={minLength}
    maxLength={maxLength}
    value={value}
    placeholder={placeholder}
    onChange={onChange}
    onPaste={onPaste}
    autoComplete={autoComplete}
    label={label}
    data-id={dataID}
    autoFocus={autoFocus}
    lineHeight={lineHeight}
    resize={resize}
    minHeight={minHeight}
    onBlur={onBlur}
    onClick={onClick}
    name={name}
    boxSizing={boxSizing}
    userSelect={userSelect}
    data-testid={testId}
    inputMode={inputMode || 'text'}
    pattern={pattern}
    {...passedProps}
  />
);

export default WishTextInputHOC(WishTextInput);
